const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit, implementFunction } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import AppData from "../../../public/const/app_data";
import { triggerAsyncId } from "async_hooks";
import GoogleBillingController from "../../../../sdk/googlebilling_controller";
import ModelData from "../../../public/model_data";
import ShopView from "./shop_view";
import { IUserCurrencyData } from "../../../../manager/user_manager";
import EventManager from "../../../../manager/event_manager";
import DialogTips from "../../../public/module/dialog_tips/dialog_tips";
import LanguageManager from "../../../../manager/language_manager";
import Utility from '../../../../utility/utility';
import { RedPointModule } from "../../../public/component/redpoint_component";
import { NotifyData } from "../../../public/notify_data";
import LoaclStorage from "../../../../manager/local_storage";

const const_tag_btn_name_map = {
    ['tag_coin']: 'PayManGuoBtn',
    ['tag_daibi']: 'PayDaiBiBtn',
    ['tag_vip']: 'VipBtn',
    ['tag_daoju']: 'DaojuBtn',
}

///充值和兑换基本显示
@ccclass
@moduleInit("Shop")
export default class  Shop extends ModuleBase<ShopView, null>  {
    // configData = null //基本配置数据
    // shopConfig = null //商品配置
    /////商城服务器定义的tag
    // 安卓：  Shop_Coin_Android,Shop_Gold_Android,Shop_VIP,Shop_Item
    // 苹果：  Shop_Coin_IOS,Shop_Gold_IOS,Shop_VIP,Shop_Item
    shopByTag = {
        Coin:"ShopCoin", //芒果币页签
        Daibi:"ShopGold", //代币页签
        Vip:"ShopVIP", //VIP商城页签
        Item:"ShopItem", //道具页签
    }
    curShowModule = null //当前显示的模块
    mallDataByCode = [] //根据约定商城tagcode 保存数据
    curBuyItemData = null
    curShopTag = null //当前商城页签Tag
    // bindBankDatas = null
    moduleNameByNode = []
    constructor() {
        super()
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = 'package/hall/module/shop/Shop_Table';
        this.viewType = ShopView;
        this.needDeferShow = true
    }
    //onDeferShow
    onDeferShow(intentData){
        this.moduleNameByNode = []
        //this.onButtonClickName("PayManGuoBtn")
        cc.log("=========================Fuck===========================", intentData)
        this.bindEvent()
        this.getPayBtnData(intentData)
    }

    protected onButtonClickName(name : string) {
        let self = this
        switch (name) {
            case "CloseBtn":
                this.hide()
                LoaclStorage.setStorageString("LAST_SHOP_KEY", self.view.curPayName)
                break
            case "PayManGuoBtn":
                this.changeShowView("PayManGuoBtn", this.shopByTag.Coin)
                break
            case "PayDaiBiBtn":
                this.changeShowView("PayDaiBiBtn", this.shopByTag.Daibi)
                break
            case "VipBtn":
                this.changeShowView("VipBtn", this.shopByTag.Vip)
                break
            case "DaojuBtn":
                this.changeShowView("DaojuBtn", this.shopByTag.Item)
                break
            case "PayBtn":
                this.view.updateBtnChoose("PayBtn", true)
                break
            case "SMSPayBtn":
                this.view.updateBtnChoose("SMSPayBtn", true)
                break
            case "BankPayBtn":
                this.view.updateBtnChoose("BankPayBtn", true)
                break
            case "7PayBtn":
                this.view.updateBtnChoose("7PayBtn", true)
                break
            case "Money1PayBtn":
                this.view.updateBtnChoose("Money1PayBtn", true)
                break
            case "Money2PayBtn":
                this.view.updateBtnChoose("Money2PayBtn", true)
                break
            case "LinePayBtn":
                this.view.updateBtnChoose("LinePayBtn", true)
                break
            default:
                break;
        }
    }

    //购买商品
    onBuyShopEvent(itemData){
        let self = this
        // if (!Utility.isNativeIOS() && ModuleManager.instance.isNoAccessShowModule(null, true, () => {
        //         self._buyItem(itemData)
        //     })) {
        //     return
        // }
        self._buyItem(itemData)
    }

    _buyItem(itemData) {
        this.curBuyItemData = itemData.Data
        if (this.curBuyItemData.costType == 1){
            if (Utility.isNativeIOS()) {
                ModuleManager.instance.showModuleName("NetPrompt", {showLongTime : true})
            } else {
                ModuleManager.instance.showModuleName("NetPrompt")
            }
            if (this.view.curPayName != "PayBtn"){
                GoogleBillingController.createOtherOrder(this.curBuyItemData.goodsCode, itemData.PriceData.payLaneId)
            }
            else{
                GoogleBillingController.purchaseInApp(this.curBuyItemData.goodsCode)
            }
            
        }
        else{
            let self = this
            let callBack = function(){
                let requestData: IHttpRequestData = {
                    baseUrl: "order/purchaseInnerOrder?",
                    showNetPrompt: true,
                    params: {
                        goodsCode: self.curBuyItemData.goodsCode,
                        onlinePayType:0,
                    }
                }
                self.apiHttpGet(requestData, function (respone) {
                    //购买是阻塞流程 所以可以保证是当前页签购买的物品
                    if (self.curShopTag == self.shopByTag.Vip){
                        EventManager.instance.dispatch('buy_vip_event')
                    }
                    else if (self.curShopTag == self.shopByTag.Item){
                        EventManager.instance.dispatch('buy_item_event')
                        if (self.curBuyItemData.goodsCode.split("_")[0] != "horn"){
                            EventManager.instance.dispatch('Event_Notify_RedPoint_Change_Refresh', RedPointModule.Bag_Vip, true) //购买道具 有新物品 直接显示背包鲜红的
                        }
                        ModuleManager.instance.showModuleName('DialogReceive', [{type:10, num:self.curBuyItemData.num, itemCode:self.curBuyItemData.sourceCode}])
                    }
                    self.getSelfCurrencyData()
                    ModuleManager.instance.toastKey("purchase_success")
                })
            }
            ModuleManager.instance.showModule(DialogTips, { Content: LanguageManager.t("pubilc_tips_buy") + this.curBuyItemData.goodsDescription, EnterCallBack:callBack})

        }
    }

    showBuyOver(goodsCode){
        if (this.curBuyItemData == null){ return }
        //购买是阻塞流程 所以可以保证是当前页签购买的物品
        if (this.curShopTag == this.shopByTag.Vip){
            EventManager.instance.dispatch('buy_vip_event')
            return
        }
        let num = this.curBuyItemData.num
        if (this.curBuyItemData.giftList) {
            this.curBuyItemData.giftList.forEach(element => {
                if (element.status){
                    num += element.num
                }
            });
        }
        if (this.curBuyItemData.goodsCode == goodsCode){
            let dataList = []
            if(this.curShopTag == this.shopByTag.Coin){
                dataList.push({type: 6, num: num})
            }
            else if(this.curShopTag == this.shopByTag.Daibi){
                dataList.push({type: 100, num: num})
            }
            ModuleManager.instance.showModuleName('DialogReceive', dataList)
        }
        ModuleManager.instance.toastKey("purchase_success")
    }

    //改变显示
    changeShowView(btnName, shopTag){
        let shopData = this.mallDataByCode[shopTag]
        this.curShopTag = shopTag
        this.view.updateBtnChoose(btnName)
        this.view.updateShopItem(shopData != null ? shopData.goodsList : [], this.curShopTag == this.shopByTag.Coin || this.curShopTag == this.shopByTag.Daibi)
    }

    //获取商城数据
    getMallData(intentData){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "mall/getMall?",
            showNetPrompt: true,
        }
        this.apiHttpGet(requestData, function (respone) {
            for (const shopData of respone.data.tagList) {
                let tagCode = shopData.tagCode.split("_")[0]
                self.mallDataByCode[tagCode] = shopData
            }
            self.show()
            self.onButtonClickName("PayManGuoBtn")
            if (intentData && intentData.tag != null){
                self.onButtonClickName(self.getBtnNameByTag(intentData.tag))
            }
        })
        
    }

    getPayBtnData(intentData){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "mall/pay-lanes?",
            showNetPrompt: true,
        }
        this.apiHttpGet(requestData, function (respone) {
            self.view.initPayBtn(respone.data, (payName)=>{
                self.onButtonClickName(payName)
            })
            self.getMallData(intentData)
        })
    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(currencyData: IUserCurrencyData) {
        let self = this
        self.view.setCurrencyData(currencyData.chip, currencyData.daibi)
    }

    private bindEvent() {
        this.eventBind('click_buy_item', this.onBuyShopEvent)
        this.eventBind("googleBillingPurchaseSuccess", this.showBuyOver)
    }

    onHide(){
        this.eventUnBind('click_buy_item', this.onBuyShopEvent)
        this.eventUnBind("googleBillingPurchaseSuccess", this.showBuyOver);
    }

    protected getBtnNameByTag(tag){
        return const_tag_btn_name_map[tag]
    }

}
